import { render, staticRenderFns } from "./HikPantalla.vue?vue&type=template&id=5a1a8cac&scoped=true&"
import script from "./HikPantalla.vue?vue&type=script&lang=ts&"
export * from "./HikPantalla.vue?vue&type=script&lang=ts&"
import style0 from "./HikPantalla.vue?vue&type=style&index=0&id=5a1a8cac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1a8cac",
  null
  
)

export default component.exports